export function honoreesAnchorActivate() {
  const header = document.querySelector('#header');
  const anchorList = document.querySelector('.top_honorees_anchor_list');
  const anchorItems = document.querySelectorAll('.top_honorees_anchor_item');
  const sections = document.querySelectorAll('.top_honorees_item');

  if (!anchorList || sections.length === 0) return;

  const rootMarginTop = header.offsetHeight + anchorList.offsetHeight + 20;
  const rootMarginBottom = window.innerHeight - rootMarginTop;

  const observerOptions = {
    root: null,
    rootMargin: `-${rootMarginTop}px 0px -${rootMarginBottom}px 0px`,
    threshold: 0,
  };

  const observer = new IntersectionObserver((entries) => {
    let activeSet = false;

    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const id = entry.target.id;
        const activeItem = document.querySelector(`.top_honorees_anchor_item a[href="#${id}"]`)?.closest('.top_honorees_anchor_item');

        if (activeItem) {
          anchorItems.forEach((item) => item.classList.remove('is-active'));
          activeItem.classList.add('is-active');
          activeSet = true;
        }
      }
    });

    // 交差中のセクションが1つもなければ is-active を外す
    if (!activeSet) {
      anchorItems.forEach((item) => item.classList.remove('is-active'));
    }
  }, observerOptions);

  sections.forEach((section) => observer.observe(section));
}
